/* eslint-disable no-underscore-dangle */
import moment from 'moment';
import FileSaver from 'file-saver';
import clonedeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import set from 'lodash/set';
import storage from 'utils/storage';
import { STATUS_ALL, STATUS_NONE, STATUS_PARTIAL } from './constants';

export const setFieldsToStorage = (entity, fields) =>
  storage.set(`$BEN$--${entity}--field`, fields);
export const getFieldsFromStorage = (entity) =>
  storage.get(`$BEN$--${entity}--field`);
export const clearFieldsFromStorage = (entity) =>
  storage.remove(`$BEN$--${entity}--field`);

export const EXPORT_READY_CLASSNAME = 'EXPORT_IS_READY';

export function preferImage(media) {
  const imgs = media.filter(({ mime }) => mime.includes('image'));

  if (imgs.length) {
    return imgs;
  }

  // if there's no image, we still can display youtube thumbs
  // But, if it's a .mov, we have to filter ir out from reports.
  return media.filter(({ url }) => url.includes('youtube'));
}

export const applyPreset = (defaultFields, presetExport) => {
  if (!presetExport) {
    return null;
  }

  const resultFields = clonedeep(defaultFields);

  Object.entries(presetExport).forEach(([key, value]) => {
    const fieldId = key.replace(
      /.__selected|.__columnCustomName|.__column/g,
      '',
    );

    if (get(defaultFields, fieldId)) {
      set(resultFields, key, value);
    }
  });

  return resultFields;
};

export const getFields = (group, onlySelecteds) => {
  const result = [];
  if (!group) {
    return [];
  }
  Object.entries(group).forEach(([key, value]) => {
    if (key.includes('__')) {
      return;
    }

    if (value.__columnGrouping) {
      result.push(...getFields(value, onlySelecteds));
      return;
    }

    if (value.__selected || !onlySelecteds) {
      result.push(value);
    }
  });
  return result.sort((a, b) => {
    if (a.__column === b.__column) {
      return 0;
    }

    if (a.__column === undefined) {
      return 1;
    }

    return a.__column > b.__column ? 1 : -1;
  });
};

export function getGroupSelectionStatus(group) {
  let some = false;
  let all = true;
  const fields = getFields(group);

  fields.forEach((field) => {
    if (field.__selected) {
      some = true;
    }
    if (!field.__selected) {
      all = false;
    }
  });

  if (all) {
    return STATUS_ALL;
  }

  return some ? STATUS_PARTIAL : STATUS_NONE;
}

export function filterSelected(groups) {
  const result = {};

  const filterGroup = (group) => {
    let hasSelected = false;
    const ngroup = {};

    Object.entries(group).forEach(([fieldName, field]) => {
      if (typeof field === 'string') {
        ngroup[fieldName] = field;
        return;
      }

      if (field.__columnGrouping) {
        const sub = filterGroup(field);

        if (sub) {
          ngroup[fieldName] = sub;
          hasSelected = true;
        }
      }

      if (field.__id && field.__selected) {
        hasSelected = true;
        ngroup[fieldName] = { ...field };

        if (field.__columnCustomName) {
          ngroup[fieldName].__columnName = field.__columnCustomName;
        }

        delete ngroup[fieldName].__selected;
        delete ngroup[fieldName].__columnCustomName;
      }
    });
    return hasSelected ? ngroup : null;
  };

  Object.entries(groups).forEach(([name, value]) => {
    const group = filterGroup(value);

    if (group) {
      result[name] = group;
    }
  });

  return result;
}

export function saveExport(response, exportType, exportTypeExt, title) {
  const ntitle = title.toLowerCase().replace(/[\W_]+/g, '_');
  const currentDate = moment().format('MMMM_DD_YYYY__hh_mm_ss').toLowerCase();
  const nexportType = exportType.toLowerCase().replace(/[\W_]+/g, '_');

  const fileName = `export_${ntitle}_${nexportType}_${currentDate}.${exportTypeExt}`;

  FileSaver.saveAs(response, fileName);
}

export function generatePresetExport(groups) {
  if (!groups) {
    return null;
  }

  const result = {};

  function itetateFields(fields) {
    Object.values(fields).forEach((field) => {
      if (field.__columnGrouping) {
        itetateFields(field);
        return;
      }

      if (!field.__id) {
        return;
      }

      if ('__selected' in field) {
        result[`${field.__id}.__selected`] = field.__selected;
      }

      if ('__columnCustomName' in field) {
        result[`${field.__id}.__columnCustomName`] = field.__columnCustomName;
      }

      if (field.__column || field.__column === 0) {
        result[`${field.__id}.__column`] = field.__column;
      }
    });
  }
  itetateFields(groups);

  return result;
}
